export default "__VITE_ASSET__CjCUIjIo__"